export default "__VITE_PUBLIC_ASSET__87717e72__"